export function WeightDiagram({ caption }) {
  return (
    <figure className="my-8 border border-[#E4E1D8] bg-[#FBFAF6] p-4 rounded-[4px]">
      <div className="w-full overflow-x-auto">
        <svg 
          viewBox="0 0 600 220" 
          className="w-full max-w-[560px] mx-auto text-[#2E3A46]" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          strokeLinecap="round" 
          strokeLinejoin="round"
          role="img"
          aria-label="Vægtfordeling og begreber mellem trækbil og påhængskøretøj"
        >
          {/* Trækbil kontur */}
          <path d="M 40 140 L 70 140 L 90 100 L 170 100 L 190 120 L 250 120 L 250 140" stroke="#2E3A46" strokeWidth="2.5" />
          <circle cx="85" cy="145" r="14" stroke="#2E3A46" strokeWidth="2.5" />
          <circle cx="215" cy="145" r="14" stroke="#2E3A46" strokeWidth="2.5" />
          
          {/* Anhængertræk & kuglekobling */}
          <line x1="250" y1="135" x2="280" y2="135" stroke="#B58200" strokeWidth="3" />
          <circle cx="280" cy="135" r="5" fill="#B58200" stroke="#B58200" />
          
          {/* Trailer vange og kasse */}
          <line x1="280" y1="135" x2="330" y2="135" stroke="#2E3A46" strokeWidth="2.5" />
          <rect x="330" y="85" width="220" height="55" rx="2" stroke="#2E3A46" strokeWidth="2.5" />
          <circle cx="440" cy="145" r="14" stroke="#2E3A46" strokeWidth="2.5" />
          
          {/* Last i trailer */}
          <rect x="350" y="95" width="180" height="35" stroke="#B58200" strokeDasharray="4 3" strokeWidth="1.5" />

          {/* Målelinjer og labels (Barlow 500, ingen tal i tegning) */}
          {/* 1. Bilens vægt */}
          <line x1="40" y1="180" x2="250" y2="180" stroke="#5C636B" strokeWidth="1" />
          <text x="145" y="198" fill="#2E3A46" fontSize="13" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Bilens tilladte totalvægt</text>
          
          {/* 2. Kugletryk */}
          <path d="M 280 90 L 280 120" stroke="#B58200" strokeWidth="2" />
          <polygon points="276,120 284,120 280,128" fill="#B58200" />
          <text x="280" y="75" fill="#B58200" fontSize="13" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Kugletryk (S-værdi)</text>
          
          {/* 3. Trailerens totalvægt */}
          <line x1="330" y1="180" x2="550" y2="180" stroke="#5C636B" strokeWidth="1" />
          <text x="440" y="198" fill="#2E3A46" fontSize="13" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Trailerens tilladte totalvægt</text>
          
          {/* 4. Nyttelast label */}
          <text x="440" y="117" fill="#B58200" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Nyttelast (gods)</text>
        </svg>
      </div>
      {caption && (
        <figcaption className="mt-3 text-center text-[14px] text-[#5C636B] italic font-sans">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

export function LightsDiagram({ caption }) {
  return (
    <figure className="my-8 border border-[#E4E1D8] bg-[#FBFAF6] p-4 rounded-[4px]">
      <div className="w-full overflow-x-auto">
        <svg 
          viewBox="0 0 600 240" 
          className="w-full max-w-[560px] mx-auto text-[#2E3A46]" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          role="img"
          aria-label="Lovpligtig lygte- og refleksføring bagpå trailer"
        >
          {/* Trailerkasse bagfra */}
          <rect x="100" y="45" width="400" height="120" rx="3" stroke="#2E3A46" strokeWidth="2.5" />
          
          {/* Hjul */}
          <rect x="75" y="105" width="25" height="70" rx="4" fill="#2E3A46" />
          <rect x="500" y="105" width="25" height="70" rx="4" fill="#2E3A46" />

          {/* Venstre lygteenhed */}
          <rect x="120" y="90" width="40" height="60" stroke="#2E3A46" strokeWidth="2" />
          <circle cx="140" cy="105" r="7" fill="#B58200" stroke="#B58200" /> {/* Blink */}
          <circle cx="140" cy="135" r="7" fill="#2E3A46" stroke="#2E3A46" /> {/* Bag/bremse */}

          {/* Højre lygteenhed */}
          <rect x="440" y="90" width="40" height="60" stroke="#2E3A46" strokeWidth="2" />
          <circle cx="460" cy="105" r="7" fill="#B58200" stroke="#B58200" /> {/* Blink */}
          <circle cx="460" cy="135" r="7" fill="#2E3A46" stroke="#2E3A46" /> {/* Bag/bremse */}

          {/* Røde trekantreflekser med spidsen opad */}
          <polygon points="190,135 175,160 205,160" fill="none" stroke="#B58200" strokeWidth="2.5" />
          <polygon points="410,135 395,160 425,160" fill="none" stroke="#B58200" strokeWidth="2.5" />

          {/* Nummerplade og nummerpladelys */}
          <rect x="250" y="115" width="100" height="35" stroke="#2E3A46" strokeWidth="1.5" />
          <line x1="280" y1="105" x2="320" y2="105" stroke="#B58200" strokeWidth="2" />

          {/* Forklarende labels: Barlow 500, med god afstand så ingen tekst rører lygtehusene */}
          {/* Lygtehus venstre dækker y: 90-150. Tekst placeres 26px over ved y=64 */}
          <text x="140" y="64" fill="#2E3A46" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Blink- og baglys</text>
          
          {/* Lygtehus højre dækker y: 90-150. Tekst placeres 26px over ved y=64 */}
          <text x="460" y="64" fill="#2E3A46" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Blink- og baglys</text>
          
          {/* Nummerpladelygte: 20px over lyslinje ved y=85 */}
          <text x="300" y="85" fill="#2E3A46" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Nummerpladelygte</text>
          
          {/* Nummerplade: Centreret i rammen */}
          <text x="300" y="137" fill="#5C636B" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Nummerplade</text>
          
          {/* Reflekser: Placeret under ved y=190, fri af alle kanter */}
          <text x="190" y="190" fill="#B58200" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Rød trekantrefleks</text>
          <text x="410" y="190" fill="#B58200" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Rød trekantrefleks</text>
        </svg>
      </div>
      {caption && (
        <figcaption className="mt-3 text-center text-[14px] text-[#5C636B] italic font-sans">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

export function LoadDimensionsDiagram({ caption }) {
  return (
    <figure className="my-8 border border-[#E4E1D8] bg-[#FBFAF6] p-4 rounded-[4px]">
      <div className="w-full overflow-x-auto">
        <svg 
          viewBox="0 0 600 200" 
          className="w-full max-w-[560px] mx-auto text-[#2E3A46]" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          role="img"
          aria-label="Regler for fremspringende last på trailer"
        >
          {/* Trailer lad */}
          <rect x="150" y="80" width="280" height="40" stroke="#2E3A46" strokeWidth="2" />
          <line x1="80" y1="110" x2="150" y2="110" stroke="#2E3A46" strokeWidth="3" />
          <circle cx="80" cy="110" r="4" fill="#2E3A46" />
          <circle cx="290" cy="135" r="14" stroke="#2E3A46" strokeWidth="2.5" />

          {/* Last der stikker bagud */}
          <line x1="160" y1="70" x2="520" y2="70" stroke="#B58200" strokeWidth="6" strokeLinecap="round" />
          
          {/* Afmærkning for enden */}
          <rect x="515" y="60" width="12" height="20" fill="#B58200" stroke="#2E3A46" strokeWidth="1" />

          {/* Målelinje for fremspring bagud */}
          <line x1="430" y1="125" x2="430" y2="160" stroke="#5C636B" strokeWidth="1" strokeDasharray="2 2" />
          <line x1="520" y1="75" x2="520" y2="160" stroke="#5C636B" strokeWidth="1" strokeDasharray="2 2" />
          <line x1="430" y1="150" x2="520" y2="150" stroke="#B58200" strokeWidth="2" />
          
          {/* Labels: Barlow 500, ingen tal i selve tegningen */}
          <text x="290" y="55" fill="#2E3A46" fontSize="13" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Gods på lad</text>
          <text x="475" y="172" fill="#B58200" fontSize="13" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Fremspring kræver afmærkning</text>
          <text x="115" y="95" fill="#5C636B" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Trækstang</text>
        </svg>
      </div>
      {caption && (
        <figcaption className="mt-3 text-center text-[14px] text-[#5C636B] italic font-sans">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

export function HitchDiagram({ caption }) {
  return (
    <figure className="my-8 border border-[#E4E1D8] bg-[#FBFAF6] p-4 rounded-[4px]">
      <div className="w-full overflow-x-auto">
        <svg 
          viewBox="0 0 600 200" 
          className="w-full max-w-[560px] mx-auto text-[#2E3A46]" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
          role="img"
          aria-label="Kuglekobling og lodret kugletryk"
        >
          {/* Trækkrog (svanehals) */}
          <path d="M 180 160 L 240 160 L 260 120" stroke="#2E3A46" strokeWidth="4" strokeLinecap="round" />
          <circle cx="260" cy="110" r="14" fill="#2E3A46" stroke="#2E3A46" />

          {/* Trailer koblingshoved (handske) */}
          <path d="M 240 98 C 240 85 280 85 280 98 L 280 115 L 380 115" stroke="#B58200" strokeWidth="3" />
          <line x1="320" y1="115" x2="330" y2="85" stroke="#B58200" strokeWidth="3" /> {/* Håndtag */}
          <circle cx="330" cy="82" r="5" fill="#B58200" />

          {/* Lodret kraftpil: Kugletryk */}
          <line x1="260" y1="35" x2="260" y2="75" stroke="#B58200" strokeWidth="3" />
          <polygon points="255,75 265,75 260,88" fill="#B58200" />

          {/* Sikkerhedswire */}
          <path d="M 230 160 C 240 180 270 180 300 135" stroke="#5C636B" strokeDasharray="3 3" strokeWidth="1.5" />

          {/* Labels: Barlow 500, tal flyttet til brødtekst */}
          <text x="260" y="25" fill="#B58200" fontSize="13" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Lodret kugletryk</text>
          <text x="210" y="145" fill="#2E3A46" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="end">Anhængerkrog på bil</text>
          <text x="350" y="140" fill="#2E3A46" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="start">Trailerens trækstang</text>
          <text x="265" y="192" fill="#5C636B" fontSize="12" fontFamily="Barlow" fontWeight="500" textAnchor="middle">Sikkerhedswire</text>
        </svg>
      </div>
      {caption && (
        <figcaption className="mt-3 text-center text-[14px] text-[#5C636B] italic font-sans">
          {caption}
        </figcaption>
      )}
    </figure>
  );
}
